import api from '../../components/apis/api';
import customerApi from '../../components/apis/customerApi';

export async function SendVerification(values) {
  return api.post(`/api/verify/${values?.verification}`, values).then((res) => res.data);
}

export async function SubmitVerification(values) {
  return api.post(`/api/verify/check-${values?.verification}`, values).then((res) => res.data);
}

export async function sendSavedCardVerification() {
  return customerApi.post('/api/verify/customer/saved-card-payment').then((res) => res.data);
}
